import { PayRule } from '@/modules/people/types/employment';
import { PAY_RULE_ENUM } from '@/modules/people/definitions';

export function getFieldNameFromRemunerationType(
  payRule: PayRule
): 'HourlyRate' | 'UnitValue' | 'AnnualSalary' {
  switch (payRule.RemunerationType) {
    case PAY_RULE_ENUM.REMUNERATION_TYPE.HOURLY.Id:
      return 'HourlyRate';
    case PAY_RULE_ENUM.REMUNERATION_TYPE.UNIT.Id:
      return 'UnitValue';
    default:
      return 'HourlyRate';
  }
}
